import { USER_SIGNUP_ERROR,  USER_SIGNUP_SUCCESS, USER_VERIFY_ERROR, USER_VERIFY_SUCCESS,
        USER_DATA_SUCCESS, USER_DATA_ERROR, USER_DATA_UPDATE_SUCCESS, EMAIL_CHANGE_SUCCESS,
        EMAIL_CHANGE_ERROR, EMAIL_VERIFY_ERROR, EMAIL_VERIFY_SUCCESS, GET_MAIL,
        CHANGE_PWORD_ERROR, CHANGE_PWORD_SUCCESS,
        FORGOT_PWORD_ERROR, FORGOT_PWORD_SUCCESS, MAIL_LISTS_SUCCESS, MAIL_LISTS_ERROR,
        UPDATE_MAIL_LISTS_SUCCESS, SET_PROFILE_SUCCESS,
        SET_PROFILE_ERROR, PROFILE_DATA_SUCCESS, PROFILE_DATA_ERROR, PROFILE_DATA_UPDATE_SUCCESS, PROFILE_DELETE_SUCCESS, PROFILE_DELETE_ERROR, PROFILE_NAME,
        CHANGE_PWORD_LOGEDIN_SUCCESS, CHANGE_PWORD_LOGEDIN_ERROR, PROFILE_ID, DELETE_USER_SUCCESS,
        ADD_ADDTOLIST, ADD_ADDTOLIST_ERROR, REMOVE_ADDTOLIST, REMOVE_ADDTOLIST_ERROR, PROFILE_ACTIVE_UPDATE, PROFILE_IS_CHILD } from '../actions/types';

import { joinDate } from '../helpers';

import { ML_LIST_1, ML_LIST_2 } from '../constants';

export function userSignUpError(state = {}, action) {
    switch(action.type) {
        case USER_SIGNUP_ERROR:
            return action.payload;
        default:
            return state;
    }
}

export function userSignUpSuccess(state = {}, action) {
    switch(action.type) {
        case USER_SIGNUP_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function userVerifyError(state = {}, action) {
    switch(action.type) {
        case USER_VERIFY_ERROR:
            return action.payload;
        default:
            return state;
    }
}

export function userVerifySuccess(state = {}, action) {
    switch(action.type) {
        case USER_VERIFY_SUCCESS:
            return { ...state, error: '', authenticated: true };
        default:
            return state;
    }
}

export function userData(state = {}, action) {
    switch(action.type) {
        case USER_DATA_SUCCESS:
            let item = action.item;
            let dobArr = item.dob.split('/');
			item.day = dobArr[0];
			item.month = dobArr[1];
			item.year = dobArr[2];

            if (item.birth_day && item.birth_month && item.birth_year) {
                item.dob = joinDate(
                    [
                        item.birth_year,
                        item.birth_month,
                        item.birth_day
                    ]);

            }
            if (item.mailing_lists && item.mailing_lists.length > 0){
                for (var i = 0, len = item.mailing_lists.length; i < len; i++) {
                    for (var key in item.mailing_lists[i]) {
                        if (key === ML_LIST_1) {
                            item.list1 = (item.mailing_lists[i][key] === "on") ? true : false;
                        }
                        if (key === ML_LIST_2) {
                            item.list2 = (item.mailing_lists[i][key] === "on") ? true : false;
                        }
                    }
                }
            }
            return item;
        case USER_DATA_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function userUpdateSuccess(state = {}, action) {
    switch(action.type) {
        case USER_DATA_UPDATE_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function changeEmail(state = {error: '', success: false}, action) {
    switch(action.type) {
        case EMAIL_CHANGE_SUCCESS:
            return { ...state, error: '', success: action.payload };
        case EMAIL_CHANGE_ERROR:
            return { ...state, error: action.payload, success: false};
        default:
            return state;
    }
}
export function verifyChangeEmail(state = {error: '', success: false}, action) {
    switch(action.type) {
        case EMAIL_VERIFY_SUCCESS:
            return { error: '', success: true };
        case EMAIL_VERIFY_ERROR:
            return { error: action.payload, success: false};
        default:
            return state;
    }
}
export function emailReducer(state = '', action) {
    switch(action.type) {
        case GET_MAIL:
            return action.payload;
        default:
            return state;
    }
}
export function changePassword(state = '', action) {
    switch(action.type) {
        case CHANGE_PWORD_SUCCESS:
            return { ...state, error: '', success: (action.payload && Object.keys(action.payload).length > 0) };
        case CHANGE_PWORD_ERROR:
            return { ...state, error: action.payload, success: false};
        default:
            return state;
    }
}
export function forgottenPassword(state = '', action) {
    switch(action.type) {
        case FORGOT_PWORD_SUCCESS:
            return { error: '', success: action.payload };
        case FORGOT_PWORD_ERROR:
            return { error: action.payload, success: false};
        default:
            return state;
    }
}

export function mailListData(state = {}, action) {
    switch(action.type) {
        case MAIL_LISTS_SUCCESS:
            return action.item;
        case MAIL_LISTS_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function mailListUpdate(state = {}, action) {
    switch(action.type) {
        case UPDATE_MAIL_LISTS_SUCCESS:
            return { ...state, success: action.payload };
        default:
            return state;
    }
}

export function profileSet(state = {}, action) {
    switch(action.type) {
        case SET_PROFILE_SUCCESS:
            return { ...state, item: action.payload};
        case SET_PROFILE_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function profileSetSuccess(state = {}, action) {
    switch(action.type) {
        case PROFILE_ACTIVE_UPDATE:
            return action.payload;
        default:
            return state;
    }
}


export function profileData(state = {}, action) { 
    switch(action.type) {
        case PROFILE_DATA_SUCCESS:
        	if (action.item.dob) {
	            let item = action.item;
	            let dobArr = item.dob.split('/');
				item.day = dobArr[0];
				item.month = dobArr[1];
				item.year = dobArr[2];
            }
            return action.item;
        case PROFILE_DATA_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function profileUpdateSuccess(state = {}, action) {
    switch (action.type) {
        case PROFILE_DATA_UPDATE_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function profileDeleteSuccess(state = {}, action) {
    switch(action.type) {
        case PROFILE_DELETE_SUCCESS:
            return action.payload;
        case PROFILE_DELETE_ERROR:
            return { ...state, error: action.payload};
        default:
            return state;
    }
}

export function profileName(state = '', action) {
    switch (action.type) {
        case PROFILE_NAME:
            return action.payload;
        default:
            return state;
    }
}

export function profileId(state = '', action) {
    switch (action.type) {
        case PROFILE_ID:
            return action.payload;
        default:
            return state;
    }
}

export function profileIsChild(state = '', action) {
    switch (action.type) {
        case PROFILE_IS_CHILD:
            return action.payload;
        default:
            return state;
    }
}

export function changePasswordLoggedIn(state = '', action) {
    switch(action.type) {
        case CHANGE_PWORD_LOGEDIN_SUCCESS:
            return { ...state, error: false, success: action.payload };
        case CHANGE_PWORD_LOGEDIN_ERROR:
            return { ...state, error: action.payload, success: false};
        default:
            return state;
      }
}

export function deleteUserSuccess(state = {}, action) {
    switch(action.type) {
        case DELETE_USER_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

export function addAddToMyList(state = {}, action) {
    switch(action.type) {
        case ADD_ADDTOLIST:
            return { ...state, error: false, success: action.payload };
        case ADD_ADDTOLIST_ERROR:
            return { ...state, error: action.payload, success: false};
        default:
            return state;
    }
}

export function removeAddToMyList(state = {}, action) {
    switch(action.type) {
        case REMOVE_ADDTOLIST:
            return { ...state, error: false, success: action.payload };
        case REMOVE_ADDTOLIST_ERROR:
            return { ...state, error: action.payload, success: false};
        default:
            return state;
    }
}
